import {
	Box, Button, Card, CardContent,
	CardHeader, Divider, Grid, InputAdornment,
	makeStyles, TextField, Typography
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import Avatar from '@material-ui/core/Avatar';
import { green, pink } from '@material-ui/core/colors';
import { useActions, useValues } from 'kea';
import profilelogic from 'src/store/profile';

const useStyles = makeStyles(() => ({
	root: {},
	green: {
		color: '#fff',
		backgroundColor: green[500],
	},
	pink: {
		color: '#fff',
		backgroundColor: pink["A400"],
	}
}));

const MobileVerification = ({ className, ...rest }) => {
	const classes = useStyles();

	const { profile } = useValues(profilelogic);
	const { updateMobile, confirmVerificationCode } = useActions(profilelogic);


	const [mobile, setMobile] = useState(profile.mobile);
	const [VCode, setVCode] = useState();

	useEffect(() => {
		setMobile(profile.mobile)
	}, [profile])


	const handleConfirm = () => confirmVerificationCode({ verification_code: VCode });

	const handleResend = () => updateMobile({ mobile })


	return (
		<form
			autoComplete="off"
			noValidate
			className={clsx(classes.root, className)}
			{...rest}
		>
			<Card>
				<CardHeader
					title="Mobile Number Verification"
					subheader="The information can be edited"
					action={
						profile.verified_mobile ?
							<Avatar className={classes.green}>
								<CheckCircleIcon />
							</Avatar>
							:
							<Avatar className={classes.pink}>
								<CancelIcon />
							</Avatar>
					}
				/>
				<Divider />
				<CardContent>
					<Grid
						container
						spacing={3}
					>
						<Grid
							item
							md={6}
							xs={12}
						>
							<TextField
								fullWidth
								label="Mobile Number"
								name="Mobile Number"
								type='string'
								error={!mobile}
								value={mobile}
								variant="outlined"
								onChange={(e) => setMobile(e.target.value)}
								InputProps={{
									endAdornment: <InputAdornment position="end">
										<Button
											color="primary"
											variant="outlined"
											onClick={handleResend}
										>
											Send Code
										</Button>
									</InputAdornment>,
								}}
							/>
						</Grid>
						{
							profile.verified_mobile ?
								<Grid
									item
									md={6}
									xs={12}
								>
									<div style={{
										display: 'flex',
										flexGrow: '1',
										paddingTop: '8px',
										paddingLeft: '30px'
									}}>
										<Avatar className={classes.green}>
											<CheckCircleIcon />
										</Avatar>
										<Typography style={{ paddingLeft: '10px', paddingTop: '8px' }} variant='h3'>
											Verified
										</Typography>
									</div>
								</Grid>
								:
								<>
									<Grid
										item
										md={6}
										xs={12}
									>
										<TextField
											fullWidth
											label="Verification Code"
											name="verification_code"
											type='number'
											onChange={e => setVCode(e.target.value)}
											error={!VCode}
											value={VCode}
											variant="outlined"
											inputProps={{
												maxLength: 6
											}}
											InputProps={{
												endAdornment: <InputAdornment position="end">
													<Button
														color="primary"
														variant="outlined"
														onClick={handleConfirm}
														style={{
															marginLeft: '10px'
														}}
													>
														Verify
													</Button>
												</InputAdornment>,
											}}
										/>
									</Grid>
								</>
						}
					</Grid>
				</CardContent>
				<Divider />
				<Box
					display="flex"
					justifyContent="flex-end"
					p={2}
				>
					{/* <Button
						color="primary"
						variant="outlined"
						onClick={handleResend}
					>
						Send Code
					</Button> */}
				</Box>
			</Card>
		</form>
	);
};

MobileVerification.propTypes = {
	className: PropTypes.string
};

export default MobileVerification;
